"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _svgIcons = require("../internal/svg-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Checkbox = function Checkbox(_ref) {
  var checked = _ref.checked,
      className = _ref.className,
      disabled = _ref.disabled,
      isError = _ref.error,
      id = _ref.id,
      indeterminate = _ref.indeterminate,
      required = _ref.required,
      restOfInputProps = _objectWithoutProperties(_ref, ["checked", "className", "disabled", "error", "id", "indeterminate", "required"]);

  var checkboxClasses = (0, _classnames.default)(className, {
    'pds-checkbox': true,
    'pds-checkbox--error': isError || required,
    'pds-checkbox--disabled': disabled,
    'pds-checkbox--indeterminate': indeterminate,
    'pds-checkbox--checked': !indeterminate && checked
  });

  var CheckMarkIcon = checked && _react.default.createElement(_svgIcons.CheckMark, {
    className: "pds-checkbox__icon--checkmark"
  });

  return _react.default.createElement("div", {
    className: checkboxClasses
  }, _react.default.createElement("input", _extends({
    className: "pds-checkbox__input"
  }, restOfInputProps, {
    checked: checked,
    id: id,
    type: "checkbox",
    "data-indeterminate": indeterminate,
    disabled: disabled,
    required: required
  })), _react.default.createElement("div", {
    className: "pds-checkbox__icon"
  }, indeterminate ? _react.default.createElement("span", null) : CheckMarkIcon));
};

Checkbox.propTypes = {
  /**
   * Whether or not the checkbox element is checked.
   */
  checked: _propTypes.bool,

  /**
   * Applies additional CSS classes to the wrapper of the `Checkbox` component.
   */
  className: _propTypes.string,

  /**
   * Whether or not the checkbox element is available to selection.
   */
  disabled: _propTypes.bool,

  /**
   * Applies error state styling to the `Checkbox` component.
   */
  error: _propTypes.bool,

  /**
   *
   */
  id: _propTypes.string.isRequired,

  /**
   * Applies indeterminate state styling to the `Checkbox` component.
   */
  indeterminate: _propTypes.bool,

  /**
   * Whether or not the HTML input is required before a form submission can occur.
   */
  required: _propTypes.bool
};
Checkbox.defaultProps = {
  checked: false,
  className: null,
  disabled: false,
  error: false,
  indeterminate: false,
  required: false
};
var _default = Checkbox;
exports.default = _default;
